import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../Baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axiosInstance from "../../api/axiosInstance";


export default function AddInventory() {
  const navigate = useNavigate();
  const allBranchSettings = useSelector((state) => state.business.allBranchSettings);
  const activeBranchId = useSelector((state) => state.business.activeBranchId);

  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [imageFile, setImageFile] = useState(null);
  const [categories, setCategories] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [vatValue, setVatValue] = useState(0);

  const [formData, setFormData] = useState({
    barcode: "",
    name: "",
    substance: "",
    unit_of_measurement: "",
    company: "",
    quantity: "",
    expiration_date: "",
    cost: "",
    price: "",
    category: "",
    strength: "",
    vat: "No",
    vat_value: 0,
    reorder_level: "10",
    preferred_vendor_id: "",
    branch_id: "",
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axiosInstance.get(`getAllCategories`);
        if (res.data.success && Array.isArray(res.data.data)) {
          setCategories(res.data.data);
        }
      } catch (err) {
        console.error("Failed to fetch categories", err);
      }
    };
    const fetchVendors = async () => {
      try {
        const res = await axiosInstance.get("getVendors");
        setVendors(res.data.data || []);
      } catch {}
    };
    fetchCategories();
    fetchVendors();
    const bid = activeBranchId || parseInt(localStorage.getItem('activeBranchId')) || "";
    if (bid) setFormData(prev => ({ ...prev, branch_id: String(bid) }));
  }, []);

  const fetchVatValue = async () => {
    try {
      const res = await axiosInstance.get('getAllVat');
      const value = Array.isArray(res?.data?.data) && res.data.data.length > 0
        ? Number(res.data.data[0].vat_value)
        : Number(res?.data?.vat_value ?? 0);
      const val = Number.isFinite(value) ? value : 0;
      setVatValue(val);
      setFormData(prev => ({ ...prev, vat_value: val }));
    } catch (e) {
      setVatValue(0);
      setFormData(prev => ({ ...prev, vat_value: 0 }));
    }
  };



  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name === "vat" && value === "Yes") {
      fetchVatValue();
    }
    if (name === "vat" && value === "No") {
      setVatValue(0);
      setFormData(prev => ({ ...prev, vat_value: 0 }));
    }
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const validate = () => {
    const err = {};
    // if (!formData.barcode.trim()) err.barcode = "Barcode is required";
    if (!formData.name.trim()) err.name = "Name is required";
    if (!formData.substance.trim()) err.substance = "Substance is required";
    if (!formData.unit_of_measurement.trim()) err.unit_of_measurement = "Unit is required";
    if (!formData.company.trim()) err.company = "Company is required";
    if (!formData.quantity.trim()) err.quantity = "Quantity is required";
    if (!formData.quantity || isNaN(formData.quantity) || formData.quantity <= 0) err.quantity = "Quantity must be a positive number";
    if (!formData.expiration_date.trim()) err.expiration_date = "Expiration date is required";
    if (!formData.cost || isNaN(formData.cost)) err.cost = "Cost must be a number";
    if (!formData.price || isNaN(formData.price)) err.price = "Price must be a number";
    // if (!formData.category) err.category = "Category is required";
    // if (!formData.strength.trim()) err.strength = "Strength is required";
    return err;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const foundErrors = validate();
    if (Object.keys(foundErrors).length > 0) {
      setErrors(foundErrors);
      setSubmitted(false);
      return;
    }

    try {
      const data = new FormData();

      // Append form fields
      Object.keys(formData).forEach((key) => {
        data.append(key, formData[key]);
      });

      // Append image if available
      if (imageFile) {
        data.append("image", imageFile);
      }

      const response = await axiosInstance.post(`addDrug`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        Swal.fire("Success", "Inventory item added successfully!", "success").then(() => {
          navigate("/Admin/Pharmacy");
        });
      } else {
        Swal.fire("Error", response.data.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Backend error:", error);
      const backendMessage = error?.response?.data?.message || "Server error while adding inventory";
      Swal.fire("Error", backendMessage, "error");
      console.error(error);
    }
  };



  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span
                  style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }}
                  onClick={() => navigate(-1)}
                  title="Back"
                >
                  &larr;
                </span>
                Add Inventory Item
              </h5>
            </div>

            {submitted && (
              <div className="alert alert-success">
                Inventory item added successfully!
              </div>
            )}

            <form
              onSubmit={handleSubmit}
              encType="multipart/form-data"
              className="row g-3 px-3 py-2 mb-3"
            >
              {/* Render all fields except category as before */}
              {[
                "barcode",
                "name",
                "substance",
                "unit_of_measurement",
                "company",
                "quantity",
                "expiration_date",
                "cost",
                "price",
                "strength",
              ].map((field) => (
                <div className="col-md-6" key={field}>
                  <label className="form-label">
                    {field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}

                    {/* ❌ barcode & strength ke liye * nahi */}
                    {field !== "barcode" && field !== "strength" && (
                      <span style={{ color: "red" }}> *</span>
                    )}
                  </label>

                  <input
                    type={
                      field === "expiration_date"
                        ? "date"
                        : field === "cost" || field === "price" || field === "quantity"
                          ? "number"
                          : "text"
                    }
                    name={field}
                    value={formData[field]}
                    onChange={handleChange}
                    className="form-control"
                    placeholder={
                      field === "barcode"
                        ? "Enter medicine barcode (optional)"
                        : field === "strength"
                          ? "Enter strength (optional)"
                          : field.replace(/_/g, " ")
                    }
                    min={
                      field === "expiration_date"
                        ? new Date().toISOString().split("T")[0]
                        : field === "quantity"
                          ? "1"
                          : undefined
                    }
                  />

                  {errors?.[field] && (
                    <p className="text-danger">{errors[field]}</p>
                  )}
                </div>
              ))}
              <div className="col-md-6">
                <label className="form-label">VAT</label>
                <select name="vat"
                  value={formData.vat}
                  onChange={handleChange}
                  className="form-select"
                >

                  <option value="No">No</option>
                  <option value="Yes">Yes</option>
                </select>
                {formData.vat === "Yes" && (
                  <div className="form-text">Appilied VAT: {vatValue}%</div>
                )}
              </div>


              {/* Category Dropdown */}
              <div className="col-md-6">
                <label className="form-label">Category <span style={{ color: "red" }}>*</span></label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className="form-control"
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
                {errors && errors.category && (
                  <p className="text-danger">{errors.category}</p>
                )}
              </div>

              {/* Reorder Level */}
              <div className="col-md-6">
                <label className="form-label">Reorder Level</label>
                <input
                  type="number" name="reorder_level"
                  value={formData.reorder_level} onChange={handleChange}
                  min="0" className="form-control"
                  placeholder="Alert when qty falls below this"
                />
              </div>

              {/* Preferred Vendor */}
              <div className="col-md-6">
                <label className="form-label">Preferred Vendor</label>
                <select name="preferred_vendor_id" value={formData.preferred_vendor_id} onChange={handleChange} className="form-control">
                  <option value="">-- None --</option>
                  {vendors.map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
                </select>
              </div>

              {/* Branch */}
              {allBranchSettings && allBranchSettings.length > 1 && (
                <div className="col-md-6">
                  <label className="form-label">Branch</label>
                  <select
                    name="branch_id"
                    value={formData.branch_id}
                    onChange={handleChange}
                    className="form-control"
                  >
                    <option value="">— None —</option>
                    {allBranchSettings.map((b, i) => (
                      <option key={b.id} value={b.id}>
                        Branch {i + 1}{b.official_name ? ` — ${b.official_name}` : ''}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Image Upload */}
              <div className="col-md-6">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  name="image"
                  className="form-control"
                  onChange={handleFileChange}
                  accept="image/*"
                />
              </div>

              <div className="col-12 mb-3 text-center">
                <button type="submit" className="bgBtn">
                  Add Inventory
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}